import { dataFileError } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFileError = /*#__PURE__*/createIcon(dataFileError)
export default IconFileError
